var ApplicationSummaryComponent_1;
import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./application-summary.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./application-summary.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { Router } from "@angular/router";
import { ApplicationSummaryConstants } from "./application-summary.constants";
import { ApplicationSummaryService } from "./shared/application-summary.service";
import { RouterParamsService } from "../../../shared/services/route-params.service";
import { SharedConstants } from "../../../shared/constants/shared.constants";
import { AppControllerService } from "../../../app-controller.service";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { AflaModuleStrategyService } from "../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AutoUnsub } from "../../../shared/decorators/autounsub.decorator";
import { CRUDOperation } from "../../models/crud-operation-enum.model";
let ApplicationSummaryComponent = class ApplicationSummaryComponent {
    static { ApplicationSummaryComponent_1 = this; }
    summaryService;
    router;
    appController;
    routeParamsService;
    changeDetectorRef;
    aflaModuleStrategyService;
    categoryLabel = ApplicationSummaryConstants.CATEGORY_LABEL;
    applicantText = ApplicationSummaryConstants.APPLICANT_TEXT;
    statusText = ApplicationSummaryConstants.STATUS_TEXT;
    applicationIdText = ApplicationSummaryConstants.APPLICATION_ID_TEXT;
    fiveDaysAgo = ApplicationSummaryConstants.FIVE_DAYS_AGO_TEXT;
    daysLeft = ApplicationSummaryConstants.DAYS_LEFT_TEXT;
    overdue = ApplicationSummaryConstants.OVERDUE_TEXT;
    daysOverdue = ApplicationSummaryConstants.DAYS_OVERDUE_TEXT;
    overdueId = ApplicationSummaryConstants.OVERDUE_ID;
    fiveDaysAgoId = ApplicationSummaryConstants.FIVE_DAYS_AGO_ID;
    noItem = SharedConstants.NO_ITEMS_AVAILABLE_MESSAGE;
    isDueLoading = false;
    isOverdueLoading = false;
    latestApplicationsSummary;
    overdueApplicationsSummary;
    activeIds;
    moduleID;
    paramsSubscription;
    getLatestApplicationsSubscription;
    getOverdueApplicationsSubscription;
    categoryOptions = [];
    categoryPlaceholder = ApplicationSummaryConstants.CATEGORY_PLACEHOLDER;
    categoryFormControlName = ApplicationSummaryConstants.CATEGORY_FORM_CONTROL_NAME;
    getLookupsObservableSubscription;
    selectedCategory = ApplicationSummaryConstants.CATEGORY_PLACEHOLDER;
    constructor(summaryService, router, appController, routeParamsService, changeDetectorRef, aflaModuleStrategyService) {
        this.summaryService = summaryService;
        this.router = router;
        this.appController = appController;
        this.routeParamsService = routeParamsService;
        this.changeDetectorRef = changeDetectorRef;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
    }
    static checkIfChanged(newValue, oldValue) {
        if (!newValue) {
            throw new Error("Value must exist");
        }
        return newValue !== oldValue;
    }
    ngOnInit() {
        this.start();
        this.getLookups();
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.appController.selectedModuleID} and name eq 'MetadataCategory'`,
        };
        this.getLookupsObservableSubscription = this.summaryService.getLookupsObservable(params).subscribe({
            next: (response) => this.onGetLookupsCompleted(response), error: (error) => {
                this.appController.handleServerErrorMessage("Application summary", error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const categoryList = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "MetadataCategory") {
                    categoryList.push(JSON.parse(item.content).value);
                }
            });
        }
        this.categoryOptions = categoryList.sort((a, b) => (a.localeCompare(b)));
    }
    viewApplication(jobId) {
        this.router.navigate([
            AppRoutingConstants.createRouteToView(this.appController.selectedModuleID + "", ApplicationSummaryConstants.VIEW_APPLICATION_ROUTE, jobId + ""),
        ]);
    }
    start() {
        this.paramsSubscription = this.routeParamsService.params.subscribe((params) => {
            this.handleRouteParamChange(params);
        });
    }
    handleRouteParamChange(params) {
        if (ApplicationSummaryComponent_1.checkIfChanged(params.moduleid, this.moduleID)) {
            this.moduleID = params.moduleid;
            this.selectedCategory = ApplicationSummaryConstants.CATEGORY_PLACEHOLDER;
            this.summaryService.setSelectedCategory(this.selectedCategory);
            this.loadStats();
        }
    }
    loadStats() {
        this.activeIds = [this.fiveDaysAgoId, this.overdueId];
        this.isOverdueLoading = true;
        this.isDueLoading = true;
        const category = this.selectedCategory === ApplicationSummaryConstants.CATEGORY_PLACEHOLDER ? null : this.selectedCategory;
        this.getLatestApplicationsSubscription = this.summaryService.getLatestApplications(+this.appController.selectedModuleID, this.aflaModuleStrategyService.applicationServiceUrl, category, this.aflaModuleStrategyService.overdueApplicationExpandFields).subscribe((success) => {
            this.latestApplicationsSummary = success;
            this.isDueLoading = false;
            this.changeDetectorRef.detectChanges();
        });
        this.getOverdueApplicationsSubscription = this.summaryService.getOverdueApplications(+this.appController.selectedModuleID, this.aflaModuleStrategyService.applicationServiceUrl, category, this.aflaModuleStrategyService.overdueApplicationExpandFields).subscribe((success) => {
            this.overdueApplicationsSummary = success;
            this.overdueApplicationsSummary.forEach((ap) => {
                ap.status.daysUntilExpired =
                    ap.status.daysUntilExpired - ApplicationSummaryConstants.DAYS_LIMIT;
            });
            this.isOverdueLoading = false;
            this.changeDetectorRef.detectChanges();
        });
    }
    onSelectedCategoryChange(category) {
        this.selectedCategory = category;
        this.summaryService.setSelectedCategory(this.selectedCategory);
        this.loadStats();
    }
    static ctorParameters = () => [
        { type: ApplicationSummaryService },
        { type: Router },
        { type: AppControllerService },
        { type: RouterParamsService },
        { type: ChangeDetectorRef },
        { type: AflaModuleStrategyService }
    ];
};
ApplicationSummaryComponent = ApplicationSummaryComponent_1 = __decorate([
    Component({
        standalone: false,
        selector: "app-application-summary",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], ApplicationSummaryComponent);
export { ApplicationSummaryComponent };
